@if (!isDismissed) {
	<div role="alert" aria-live="polite" class="alert {{ alertClass }}">
		<div class="alert-block">
			<span aria-hidden="true" class="fa fa-2x {{ alertIconClass }}"></span>
			<span class="alert-message">{{ alert.message }}</span>
			@if (canDismiss) {
				<button
					class="close-button"
					(click)="removeAlert()"
					data-cy="close-alert-x"
				>
					<span aria-hidden="true" class="fa fa-times"></span>
				</button>
			}
		</div>
	</div>
}
